import { Component, OnInit,Output, EventEmitter,ViewChild,TemplateRef } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {

// paginated email data
//emailData: Array<Email>;
emailIds: number[] = [];
// page number
page = 1;
// default page size
pageSize = 10;
// total number of records
totalRecords = 0;

// start and end index
startIndex = 1;
endIndex = 10;
strWsnoti: string = "api/servicios/Notificaciones";
strActualizarNoti : string = "api/servicios/ActualizarEstadoNotificacion";
data: Array<any> = [];
pagedata: Array<any> = [];
WsLlaves : string = '';
id : string = '';
estado: string = "";
cantidad : string = "";
cantidadleido : string = "";
cantidadnoleido : string = "";
cantidadImportante : string = "";
emailSelected = 'T';
currentPage: number;
itemsPerPage: number = 10;
number = [10, 20, 30, 40];
intPAD14CON: string;

@Output() AbrirNuevoNavnoti = new EventEmitter<string>();
@ViewChild('contenido') contenido:TemplateRef<any>;

  constructor(private dataService: SharedService,
              private modalService: NgbModal) { }

  ngOnInit(): void {
    this.initialize('T');
  }

  initialize(val): void {

    this.data = [];
    this.dataService.ConsultarWS(this.strWsnoti, JSON.stringify({filtro: val})).subscribe((datosResp: any) => {
      this.data = datosResp.DATA;
      this.intPAD14CON = datosResp.DATA.PAD14CON;

      this.pagedata = datosResp.DATA;
      this.totalRecords = datosResp.TOTAL;
      this.endIndex = datosResp.TOTAL;
      this.cantidadleido = datosResp.LEIDO;
      this.cantidadnoleido = datosResp.NOLEIDO;
      this.cantidadImportante = datosResp.IMPORTANTE;
      this.cantidad = datosResp.TOTAL;

      if(this.estado != val)this.page = 1;
      this.onPageChange(this.page);
      this.estado = val;
    });
    this.emailSelected = val;
  }

  selectMail(event, id) {
    this.id = id
    if (event.target.checked) {
      this.emailIds.push(id);
    } else {
      this.emailIds.splice(this.emailIds.indexOf(id), 1);
    }
  }

  markUnread(PAD14LEO, PAD14IMP?) {
    let acciones;
    if(PAD14IMP != null){
      acciones = {importante: PAD14IMP};
    }else{
      acciones = {leido: PAD14LEO};
    }
    if(this.emailIds.length > 0){
      for (let i = 0; i < this.emailIds.length; i++) {
        var id = this.emailIds[i];
        this.dataService.ConsultarWS(this.strActualizarNoti+"/"+id, JSON.stringify(acciones)).subscribe((datosResp2: any) => {
          this.data = datosResp2;

          if(i == (this.emailIds.length - 1)){
            if(this.estado == "") {
              this.estado = 'T';
            }
            this.emailIds = [];
            this.initialize(this.estado);
          }
        });
      }
    }else{
      this.dataService.ConsultarWS(this.strActualizarNoti+"/"+this.id, JSON.stringify(acciones)).subscribe((datosResp2: any) => {
        this.data = datosResp2
        if(this.estado == "") this.estado = 'T';
        this.initialize(this.estado);
      });
    }
  }

  pageChange(event) {
    this.page = event;
    this.currentPage = event;
    this.onPageChange(event);
  }

  countNumber(event: any) {
    const newSize = Number(event);
    this.pageSize = newSize;
    this.itemsPerPage = newSize;
    this.page = 1;
    this.onPageChange(this.page);
  }

  onPageChange(page: any): void {
    const p = Number(page) || 1;
    this.page = p;
    this.currentPage = p;
  
    this.startIndex = ((p - 1) * this.pageSize) + 1;
    this.endIndex = ((p - 1) * this.pageSize) + this.pageSize;
    if (this.endIndex > this.totalRecords) {
      this.endIndex = this.totalRecords;
    }
  
    if (!this.pagedata || this.pagedata.length === 0) {
      this.data = [];
      return;
    }
  
    this.data = this.pagedata.slice(this.startIndex - 1, this.endIndex);
  }

  cambio(val){
    this.initialize(val);
  }

  agregarImportante(email){
    this.emailIds = [];
    this.id = email.PAD14CON;
    if(email.PAD14IMP == 'S'){
      this.markUnread('', 'N');
    }else{
      this.markUnread('', 'S');
    }
  }

  EventoClickLista(id) {
    this.id = id;
    this.WsLlaves = id;
    this.modalService.open(this.contenido, {fullscreen: true });
    let email = this.data.find((correo : any) => correo.PAD14CON == id);
    if(email.PAD14LEO == 'N'){
      this.markUnread("S");
    }
  }

  selectAllTotalFlag: boolean = false;

  selectAllOnPage() {
    if (!this.data || this.data.length === 0) return;
    for (const e of this.data) {
      if (this.emailIds.indexOf(e.PAD14CON) === -1) {
        this.emailIds.push(e.PAD14CON);
      }
    }
    this.selectAllTotalFlag = false;
  }

  selectAllTotal() {
    this.selectAllTotalFlag = true;
  }

  clearAllSelection() {
    this.emailIds = [];
    this.selectAllTotalFlag = false;
  }

  toggleSelectPage(event: any) {
    const checked = event.target.checked;
    if (checked) {
      this.selectAllOnPage();
    } else {
      if (!this.data || this.data.length === 0) return;
      for (const e of this.data) {
        const idx = this.emailIds.indexOf(e.PAD14CON);
        if (idx > -1) this.emailIds.splice(idx, 1);
      }
      this.selectAllTotalFlag = false;
    }
  }
}